module.exports = __webpack_public_path__ + "img/ph-2.c5229fac.png";